// development api (desktop)
// export const API = {
//     API_URL: "http://127.0.0.1:8000/api/admin",   // Laravel API prefix
//     IMAGE_BASE_URL: "http://127.0.0.1:8000/storage", // Public storage folder
//     SIGN_API_URL: "http://localhost:3000",
// };


// development api (mobile)
// export const API = {
//    API_URL: "http://192.168.1.4:8000/api/admin",   // Laravel API prefix
//    IMAGE_BASE_URL: "http://192.168.1.4:8000/storage", // Public storage folder
//    SIGN_API_URL: "http://192.168.1.4:3000",
// };

// production api
   export const API = {
      API_URL: "https://api.wipnttech.com/api/admin/",   // Laravel API prefix
      IMAGE_BASE_URL: "https://api.wipnttech.com/storage", // Public storage folder
      SIGN_API_URL: "https://api.wipnttech.com",
   };